module.exports = __webpack_public_path__ + "media/AUDIO 09.492ad73f.mp3";